import { Button } from "@tellescope/ui";
import { Card } from "@tellescope/design-system";
import { useTranslation } from "react-i18next";

interface ErrorPageProps {
  error?: string;
  actionLabel?: string;
  onAction?: () => void;
}

export const ErrorPage = ({ error, actionLabel, onAction }: ErrorPageProps) => {
  const { t } = useTranslation();

  const displayError = error || t("No valid session. Please use a valid portal access link.");

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-8">
      <Card variant="floating" padding="root" className="w-full max-w-md">
        <Card.Header className="text-center">
          <Card.Title className="text-2xl font-bold text-destructive">{t("Access Error")}</Card.Title>
        </Card.Header>
        <Card.Body className="space-y-4 text-center">
          <p className="text-muted-foreground">{displayError}</p>
          <p className="text-sm text-muted-foreground">
            {t("If you believe this is an error, please contact your healthcare provider for a new access link.")}
          </p>
          {onAction && actionLabel && (
            <div className="pt-4">
              <Button variant="outline" onClick={onAction}>
                {actionLabel}
              </Button>
            </div>
          )}
        </Card.Body>
      </Card>
    </div>
  );
};
